import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import history from './history';
import router from './router';
import routes from './routes';

import injectTapEventPlugin from 'react-tap-event-plugin';
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as Colors from 'material-ui/styles/colors';
import {fade} from 'material-ui/utils/colorManipulator';

import './bootstrap.css';

const container = document.getElementById('root');

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
const muiTheme = {
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: Colors.blueGrey800,
    primary2Color: Colors.blueGrey600,
    primary3Color: Colors.blueGrey200,
    accent1Color: Colors.green600,
    accent2Color: Colors.green800,
    accent3Color: Colors.green200,
    textColor: fade(Colors.darkBlack, 0.93),
    lightTextColor: fade(Colors.darkBlack, 0.7),
    alternateTextColor: fade(Colors.white, 0.93),
    canvasColor: Colors.grey50,
    borderColor: Colors.grey300,
    disabledColor: fade(Colors.darkBlack, 0.3),
    pickerHeaderColor: Colors.blueGrey500,
    clockCircleColor: fade(Colors.darkBlack, 0.07),
    shadowColor: Colors.fullBlack,
    primaryPanel: Colors.blueGrey500,
    alternatePanel: Colors.grey50,
    butterbarColor: Colors.amber100,
  },
};

function renderComponent(component) {
  ReactDOM.render(
      <MuiThemeProvider muiTheme={getMuiTheme(muiTheme)}>
        {component}
      </MuiThemeProvider>
    , container);
}

function render(location, action) {
  router.resolve(routes, location)
    .then(renderComponent)
    .catch(error => router.resolve(routes, { ...location, error })
    .then(renderComponent));
}

render(history.location); // render the current URL
history.listen(render);   // render subsequent URLs



// WEBPACK FOOTER //
// ./src/index.js